export default {
  coaDetail_00001: "",
};